import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAPIErrorMessage, digitString } from 'utils';

import moment from 'moment';
import { PostTourRequestAPI } from 'api/application';
import { GetTermsAPI } from 'api/site';
import { siteActions } from 'store/site';
import Modal from 'components/common/Modal';
import ModalTerms from 'components/Popup/ModalTerms';

import {
  CORRECT_PHONE_MSG,
  EMAIL_UNMATCH_MSG,
  RequiredMessage,
  SelectMessage,
} from 'constants/message';
import { TourRequestApplicationForm } from 'store/application/type';
import { isEmail, isPhone } from 'constants/reg';
import { AxiosResponse } from 'axios';
import Calendar from 'react-calendar';
import { useRouter } from 'next/router';

interface IProps {
  closeModal: () => void;
}

const ModalTourRequest: React.FC<IProps> = ({ closeModal }: IProps) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    openModal: openTermsModal,
    ModalPortal: TermsModalPortal,
    closeModal: closeTermsModal,
  } = Modal();

  const openTerms = async () => {
    const response = await GetTermsAPI('inquiry');
    if (!response?.data) return;
    dispatch(siteActions.getTerm(response.data));
    openTermsModal();
  };

  // Post Value
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [note, setNote] = useState('');
  const [person, setPerson] = useState<number | null>(null);
  const [date, setDate] = useState();
  const [open, setOpen] = useState(false);
  const [area, setArea] = useState('');
  const [duration, setDuration] = useState('');
  const [survey1, setSurvey1] = useState('');
  const [survey2, setSurvey2] = useState('');
  const [serviceOption, setServiceOption] = useState('');

  // Help Value
  const [isAreaErr, setIsAreaErr] = useState(false);
  const [isDateErr, setIsDateErr] = useState(false);
  const [isDurationErr, setIsDurationErr] = useState(false);
  const [isPersonErr, setIsPersonErr] = useState(false);
  const [isSurvey1Err, setIsSurvey1Err] = useState(false);
  const [isSurvey2Err, setIsSurvey2Err] = useState(false);

  const [nameHelp, setNameHelp] = useState('');
  const [phoneHelp, setPhoneHelp] = useState('');
  const [emailHelp, setEmailHelp] = useState('');
  const [noteHelp, setNoteHelp] = useState('');
  const [serviceOptionHelp, setServiceOptionHelp] = useState('');

  // onChange
  const onChangeName = (event: React.ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);
  const onChangePhone = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    // 숫자만 추출
    const numbers = value.replace(/[^0-9]/g, '');

    if (numbers.length <= 11) {
      // 숫자 길이에 따라 하이픈 추가
      let formattedNumber = '';
      if (numbers.length <= 3) {
        formattedNumber = numbers;
      } else if (numbers.length <= 7) {
        formattedNumber = `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
      } else {
        formattedNumber = `${numbers.slice(0, 3)}-${numbers.slice(
          3,
          7,
        )}-${numbers.slice(7)}`;
      }
      setPhone(formattedNumber);
    }
  };
  const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) =>
    setEmail(event.target.value);
  const onChangeNote = (event: React.ChangeEvent<HTMLTextAreaElement>) =>
    setNote(event.target.value);
  const onChangeDuration = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setDuration(event.target.value);
  const onChangeSurvey1 = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSurvey1(event.target.value);
  const onChangeSurvey2 = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSurvey2(event.target.value);

  const onChangePerson = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (!Number.isInteger(Number(value))) {
      setPerson(1);
      return;
    }

    const num = Number(value);

    if (num > 99) {
      setPerson(1);
      return;
    }
    setPerson(num);
  };
  const onChangeCalendar = event => {
    setDate(event);
    setOpen(false);
  };

  const onChangeArea = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setArea(event.target.value);

  const onChangeServiceOption = (value: string) => setServiceOption(value);

  const clickRequest = async () => {
    if (!validate()) return;

    const TourRequest: TourRequestApplicationForm = {
      name,
      phone_number: phone,
      email,
      content: note,
      service: serviceOption,
      area,
      expected_date: moment(date).format('YYYY-MM-DD'),
      duration,
      num_members: Number(person),
      survey1,
      survey2,
      channel: '공식',
      marketing_agreement: false, // 광고성/마케팅 동의 항목 제거 (DDPS 요청, 불필요 항목) → false 고정
      privacy_agreement: true, // 동의 항목 → 단순 안내(고지)로 전환, 고지받음으로 처리
    };

    const response: AxiosResponse = await PostTourRequestAPI(TourRequest);

    if (response.status >= 400) {
      alert(getAPIErrorMessage(response));
      return;
    }

    await router.push('/tour/request_complete');
  };
  const clickCalendar = () => setOpen(!open);

  // validate
  const validate = () => {
    let validationCheck = true;
    if (!name.length) {
      document.getElementById('name').focus();
      setNameHelp(RequiredMessage('이름'));
      validationCheck = false;
    } else {
      setNameHelp('');
    }

    if (!serviceOption) {
      setServiceOptionHelp(SelectMessage('서비스'));
      validationCheck = false;
    } else {
      setServiceOptionHelp('');
    }

    if (!phone.length) {
      document.getElementById('tell').focus();
      setPhoneHelp(RequiredMessage('연락처'));
      validationCheck = false;
    } else {
      setPhoneHelp('');
    }

    if (!email.length) {
      document.getElementById('email').focus();
      setEmailHelp(RequiredMessage('이메일'));
      validationCheck = false;
    } else {
      setEmailHelp('');
    }

    if (!note.length) {
      document.getElementById('email').focus();
      setNoteHelp(RequiredMessage('궁금하신 내용'));
      validationCheck = false;
    } else {
      setNoteHelp('');
    }

    if (!isPhone(phone)) {
      document.getElementById('tell').focus();
      setPhoneHelp(CORRECT_PHONE_MSG);
      validationCheck = false;
    } else {
      setPhoneHelp('');
    }

    if (!isEmail(email)) {
      document.getElementById('email').focus();
      setEmailHelp(EMAIL_UNMATCH_MSG);
      validationCheck = false;
    } else {
      setEmailHelp('');
    }

    if (!area) {
      setIsAreaErr(true);
      validationCheck = false;
    } else {
      setIsAreaErr(false);
    }

    if (!duration) {
      setIsDurationErr(true);
      validationCheck = false;
    } else {
      setIsDurationErr(false);
    }

    if (!survey1) {
      setIsSurvey1Err(true);
      validationCheck = false;
    } else {
      setIsSurvey1Err(false);
    }

    if (!survey2) {
      setIsSurvey2Err(true);
      validationCheck = false;
    } else {
      setIsSurvey2Err(false);
    }

    if (!Number(person)) {
      setIsPersonErr(true);
      validationCheck = false;
    } else {
      setIsPersonErr(false);
    }

    if (!moment(date, 'YYYY.MM.DD', true).isValid()) {
      setIsDateErr(true);
      validationCheck = false;
    } else {
      setIsDateErr(false);
    }

    return validationCheck;
  };

  // Calendar Disabled
  const tileDisabled = ({ date: calendarDate }) => {
    const today = new Date().setHours(0, 0, 0, 0);
    return calendarDate < today;
  };

  return (
    <>
    <div className="dimd-layer">
      <div className="inner sz-type">
        <section className="invite-w">
          <h1>투어.입주문의</h1>
          <div className="form-w">
            <em className="tit" id="service">
              원하는 서비스를 선택해주세요.
            </em>
            {serviceOptionHelp !== '' ? (
              <p className="err">{serviceOptionHelp}</p>
            ) : null}
            <div className="form-group">
              <div className="radio-group">
                {[
                  { title: '오피스', subtitle: '독립 사무실' },
                  { title: '고정석', subtitle: '1인 데스크' },
                  { title: '코리빙', subtitle: '한달이상 거주' },
                  { title: '기타', subtitle: '단체/B2B 등' },
                ].map((option, index) => (
                  <div
                    key={index}
                    className={`radio-option ${
                      serviceOption === option.title ? 'selected' : ''
                    }`}
                    onClick={() => onChangeServiceOption(option.title)}
                  >
                    <strong>{option.title}</strong>
                    <small>{option.subtitle}</small>
                  </div>
                ))}
              </div>
            </div>
            <div className="form-group">
              <select
                id="select1"
                value={area}
                onChange={onChangeArea}
                className={isAreaErr && 'err'}
                required
              >
                <option disabled value="" selected>
                  가장 선호하는 지역을 선택해주세요*
                </option>
                <option value="마포/양천구">마포/양천구</option>
                <option value="중구">중구</option>
                <option value="강남구">강남구</option>
                <option value="기타/지역 무관">기타/지역 무관</option>
              </select>
            </div>
            <div className="form-group">
              <input
                type="text"
                id="hopSt"
                placeholder="입주 희망일을 알려주세요*"
                value={date ? moment(date).format('YYYY.MM.DD') : ''}
                onClick={clickCalendar}
                readOnly
                style={{ cursor: 'pointer' }}
                className={isDateErr && 'err'}
              />
              {open ? (
                <Calendar
                  onChange={onChangeCalendar}
                  value={date}
                  tileDisabled={tileDisabled}
                />
              ) : null}
            </div>

            <div className="form-group">
              <select
                required
                id="select3"
                value={duration}
                onChange={onChangeDuration}
                className={isDurationErr && 'err'}
              >
                <option disabled value="" selected>
                  이용 희망 기간을 선택해주세요*
                </option>
                <option value="1-3개월">1-3개월</option>
                <option value="4-6개월">4-6개월</option>
                <option value="7개월 이상">7개월 이상</option>
              </select>
            </div>

            <div className="form-group">
              <input
                type="text"
                id="numericInput"
                value={person}
                onChange={onChangePerson}
                placeholder="이용 인원을 알려주세요(숫자만 기입)*"
                className={isPersonErr && 'err'}
              />
            </div>

            <div className="form-group">
              <select
                id="select5"
                value={survey1}
                onChange={onChangeSurvey1}
                className={isSurvey1Err && 'err'}
                required
              >
                <option disabled value="" selected>
                  공간을 구할 때 가장 중요하게 생각하는 점이 있나요?*
                </option>
                <option value="다양한 공용 공간">다양한 공용 공간</option>
                <option value="감각적인 공간 인테리어">
                  감각적인 공간 인테리어
                </option>
                <option value="합리적인 비용">합리적인 비용</option>
                <option value="편리한 교통편·위치">편리한 교통편·위치</option>
                <option value="공간 컨디션 및 시설 편의">
                  공간 컨디션 및 시설 편의
                </option>
                <option value="멤버 커뮤니티·네트워킹">
                  멤버 커뮤니티·네트워킹
                </option>
              </select>
            </div>
            <div className="form-group">
              <select
                id="select4"
                value={survey2}
                onChange={onChangeSurvey2}
                className={isSurvey2Err && 'err'}
                required
              >
                <option disabled value="" selected>
                  로컬스티치를 어떤 경로로 알게 되셨나요?*
                </option>
                <option value="지인 추천">지인추천</option>
                <option value="인터넷 검색 (네이버/구글)">
                  인터넷 검색 (네이버/구글)
                </option>
                <option value="SNS/광고 (인스타그램/페이스북/이메일)">
                  SNS/광고 (인스타그램/페이스북/이메일)
                </option>
                <option value="오프라인 지점 방문 경험(커뮤니티 프로그램/행사, 브랜드숍)">
                  오프라인 지점 방문 경험(커뮤니티 프로그램/행사, 브랜드숍)
                </option>
                <option value="로컬스티치 입주·구독 경험(오피스,고정석,코리빙,멤버십)">
                  로컬스티치 입주·구독 경험(오피스,고정석,코리빙,멤버십)
                </option>
                <option value="기타">기타</option>
              </select>
            </div>

            <em className="tit" id="service">
              상담을 위한 정보를 입력해주세요.
              <br />
              1:1 맞춤 상담을 통해 최적의 공간을 제안해드릴게요.
            </em>

            <input
              type="text"
              id="name"
              placeholder="이름*"
              value={name}
              onChange={onChangeName}
              className={nameHelp && 'err'}
            />
            {nameHelp !== '' ? <p className="err">{nameHelp}</p> : null}
            <input
              type="text"
              id="tell"
              placeholder="연락처 (010-1234-5678)*"
              value={phone}
              onChange={onChangePhone}
              className={phoneHelp && 'err'}
            />
            {phoneHelp !== '' ? <p className="err">{phoneHelp}</p> : null}
            <input
              type="text"
              id="email"
              placeholder="이메일*"
              value={email}
              onChange={onChangeEmail}
              className={emailHelp && 'err'}
            />
            {emailHelp !== '' ? <p className="err">{emailHelp}</p> : null}
            <textarea
              id="email"
              placeholder={`궁금하신 내용을 작성해주세요.*
(예: 3개월 동안 살면서 일할 수 있는 공간을 찾고 싶어요, 회사에서 워케이션을 준비하고 있어요, 우리 팀에 맞는 오피스 공간을 찾고 있어요 등)`}
              value={note}
              onChange={onChangeNote}
              className={noteHelp && 'err'}
              maxLength={1000}
            />
            {noteHelp !== '' ? <p className="err">{noteHelp}</p> : null}
            <div className="note-box">
              작성해주신 정보는 맞춤 투어 및 상담자료로만 활용되며
              <br />
              신청일로부터 3개월 동안 보관됩니다.
            </div>
          </div>
          <div className="agree-box">
            <p>
              <span>
                [필수 안내] 문의 및 상담 개인정보 수집·이용 (
                <a onClick={openTerms} style={{ cursor: 'pointer' }}>
                  보기
                </a>
                )
              </span>
            </p>
          </div>
          <div className="ly-btn intype2">
            <a
              onClick={clickRequest}
              style={{ cursor: 'pointer', marginBottom: '80px' }}
            >
              문의하기
            </a>
          </div>
          <button type="button" className="btn-close" onClick={closeModal}>
            <span>팝업 닫기</span>
          </button>
        </section>
      </div>
    </div>
    <TermsModalPortal>
      <ModalTerms closeModal={closeTermsModal} />
    </TermsModalPortal>
    </>
  );
};

export default ModalTourRequest;
